import { createGlobalStyle } from 'styled-components';

const GlobalStyles = createGlobalStyle`
  @import url('https://fonts.googleapis.com/css2?family=Poppins:wght@300;400;500;600;700&family=Roboto:wght@300;400;500;700&display=swap');
  
  * {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
  }

  html {
    scroll-behavior: smooth;
  }

  body {
    font-family: ${props => props.theme.fonts.primary};
    line-height: 1.6;
    color: ${props => props.theme.colors.dark};
    background-color: ${props => props.theme.colors.white};
    overflow-x: hidden;
  }

  h1, h2, h3, h4, h5, h6 {
    font-family: ${props => props.theme.fonts.primary};
    font-weight: 600;
    line-height: 1.2;
    margin-bottom: 1rem;
  }

  h1 {
    font-size: 2.5rem;
    @media (max-width: ${props => props.theme.breakpoints.mobile}) {
      font-size: 2rem;
    }
  }

  h2 {
    font-size: 2rem;
    @media (max-width: ${props => props.theme.breakpoints.mobile}) {
      font-size: 1.75rem;
    }
  }

  h3 {
    font-size: 1.5rem;
    @media (max-width: ${props => props.theme.breakpoints.mobile}) {
      font-size: 1.25rem;
    }
  }

  p {
    margin-bottom: 1rem;
    font-size: 1rem;
    font-family: 'Times New Roman', Times, serif;
    color: #000000;
    line-height: 1.6;
  }

  /* Content text styling - serif font for all content */
  .content-text, span, div:not(.heading), li {
    font-family: 'Times New Roman', Times, serif;
    color: #000000;
  }

  a {
    text-decoration: none;
    color: inherit;
    transition: all 0.3s ease;
  }

  button {
    cursor: pointer;
    border: none;
    outline: none;
    font-family: inherit;
  }

  img {
    max-width: 100%;
    height: auto;
  }

  .container {
    max-width: 1200px;
    margin: 0 auto;
    padding: 0 20px;
  }

  .section {
    padding: 80px 0;
    @media (max-width: ${props => props.theme.breakpoints.mobile}) {
      padding: 60px 0;
    }
  }

  .btn {
    display: inline-block;
    padding: 12px 30px;
    border-radius: 5px;
    font-weight: 500;
    text-align: center;
    transition: all 0.3s ease;
    cursor: pointer;
    border: none;
    outline: none;
    
    &.btn-primary {
      background: ${props => props.theme.colors.primary};
      color: ${props => props.theme.colors.white};
      
      &:hover {
        background: ${props => props.theme.colors.dark};
        transform: translateY(-2px);
      }
    }
    
    &.btn-secondary {
      background: ${props => props.theme.colors.secondary};
      color: ${props => props.theme.colors.white};
      
      &:hover {
        background: #e67e22;
        transform: translateY(-2px);
      }
    }
  }

  .text-center {
    text-align: center;
  }

  .text-left {
    text-align: left;
  }

  .text-right {
    text-align: right;
  }

  .mb-1 { margin-bottom: 0.5rem; }
  .mb-2 { margin-bottom: 1rem; }
  .mb-3 { margin-bottom: 1.5rem; }
  .mb-4 { margin-bottom: 2rem; }
  .mb-5 { margin-bottom: 3rem; }

  .mt-1 { margin-top: 0.5rem; }
  .mt-2 { margin-top: 1rem; }
  .mt-3 { margin-top: 1.5rem; }
  .mt-4 { margin-top: 2rem; }
  .mt-5 { margin-top: 3rem; }

  .grid {
    display: grid;
    gap: 2rem;
  }

  .grid-2 {
    grid-template-columns: repeat(2, 1fr);
    @media (max-width: ${props => props.theme.breakpoints.mobile}) {
      grid-template-columns: 1fr;
    }
  }

  .grid-3 {
    grid-template-columns: repeat(3, 1fr);
    @media (max-width: ${props => props.theme.breakpoints.tablet}) {
      grid-template-columns: repeat(2, 1fr);
    }
    @media (max-width: ${props => props.theme.breakpoints.mobile}) {
      grid-template-columns: 1fr;
    }
  }

  .grid-4 {
    grid-template-columns: repeat(4, 1fr);
    @media (max-width: ${props => props.theme.breakpoints.tablet}) {
      grid-template-columns: repeat(2, 1fr);
    }
    @media (max-width: ${props => props.theme.breakpoints.mobile}) {
      grid-template-columns: 1fr;
    }
  }

  .flex {
    display: flex;
  }

  .flex-center {
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .flex-between {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  .flex-column {
    flex-direction: column;
  }

  @media (max-width: ${props => props.theme.breakpoints.mobile}) {
    .flex {
      flex-direction: column;
    }
  }
`;

export default GlobalStyles; 